import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { onUnmount } from 'lp-hoc'
import * as firebaseSvc from 'firebase-service'

const propTypes = {
  children: PropTypes.node.isRequired,
}

const defaultProps = {}

function Layout ({ children }) {
  return (
    <div>
      { children }
    </div>
  )
}

Layout.propTypes = propTypes

Layout.defaultProps = defaultProps

export default compose(
  onUnmount(() => firebaseSvc.closeFirebaseConnection())
)(Layout)

